import React from "react";

import userImg from "assets/images/activities/one-user.png";
import teamActImg from "assets/images/activities/act-team.png";
import sliceActImg from "assets/images/activities/act-slice.png";
import squeezeActImg from "assets/images/activities/act-squeeze.png";

const ViewActivity = ({ onBackClick, view_activity, onStartActivity }) => {
  const getTypeName = () => view_activity.type.split(" ")[0].toLowerCase();

  const handleStart = (activity) => {
    if (getTypeName() === "team")
      window.location.href = "https://heylime.com/events";
    else onStartActivity(activity);
  };

  return (
    <>
      <button className="activities-back-btn" onClick={onBackClick}>
        Back
      </button>
      <section className="activity-info">
        <div className="game-name">
          <p className="name">{view_activity.activity.label}</p>
          <div className="d-flex align-items-center">
            <p className="mb-0 me-5">{view_activity.activity.categories[0]}</p>
            <div className="me-5 d-flex align-items-center">
              <img src={userImg} className="img-fluid userImg1" alt="" />
              <img src={userImg} className="img-fluid userImg me-2" alt="" />
              <p className="mb-0">{view_activity.activity.players}</p>
            </div>
            <div className="d-flex align-items-center">
              <img
                src={
                  getTypeName() === "squeeze"
                    ? squeezeActImg
                    : getTypeName() === "slice"
                    ? sliceActImg
                    : teamActImg
                }
                className="img-fluid image"
                alt="squezeesImg"
              />
              <p className="mb-0">{view_activity.type}</p>
            </div>
          </div>
        </div>
        <div className="game-content-main">
          <img src={view_activity.activity.logo} className="gameImg" alt="" />
          <div className="content">
            <h2 className="title">Overview</h2>
            <p className="desc">{view_activity.activity.text}</p>
          </div>
        </div>
        <button
          className="start-btn"
          onClick={() => handleStart(view_activity.activity)}
        >
          {`${view_activity.activity.button_text} ${
            getTypeName() === "team" ? "" : "Activity"
          }`}
        </button>
      </section>
    </>
  );
};

export default ViewActivity;
